<template>
  <div v-if="visible" class="overlay" @click.self="close">
    <v-card class="image-modal">
      <v-card-title class="d-flex align-center primary justify-space-between">
        <div class="white--text">Imagen</div>
        <v-btn class="mt-2 ml-3" color="red"  @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="image-container">
        <v-img 
          max-height="600"  
          contain  
          :src="imageUrl" 
          class="contained-image"
        >
          <template v-slot:placeholder>
            <v-row justify="center" align="center" style="height: 80vh">
              <v-col cols="12" class="text-center">
                <v-progress-circular size="80" width="5" color="primary" indeterminate></v-progress-circular>
                <div class="mt-4 text-h6">Cargando...</div>
              </v-col>
            </v-row>
          </template>
        </v-img>
      </div>
    </v-card>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
